import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, HelpCircle, AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="bg-white" data-id="element-106">
      {/* Agitation Part - Deep Emotional Pain */}
      <div className="py-20 container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-108">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-109">
            Conozco bien esa frustración.
          </h2>

          <div className="text-left max-w-2xl mx-auto space-y-4 text-lg text-gray-600 leading-relaxed mb-10" data-id="element-110">
            <p data-id="element-111">
              Cortaste un tallo con cuidado. Lo pusiste en agua, o en tierra,
              como viste en algún video. Esperaste días. Semanas. Y lo que
              encontraste fue una ramita muerta, podrida, o simplemente sin
              ningún signo de vida.
            </p>
            <p className="font-medium text-gray-800" data-id="element-112">
              Y lo peor no es el esqueje perdido.
            </p>
            <p data-id="element-113">
              Lo peor es esa vocecita interna que dice:{' '}
              <em data-id="element-114">"No es para mí. Yo no puedo."</em>
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-115">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center justify-center gap-2" data-id="element-116">
              <HelpCircle className="w-6 h-6 text-[#4a7c2c]" data-id="element-117" />
              Pero hay algo más doloroso que fracasar: no saber por qué
              fallaste.
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 text-left max-w-2xl mx-auto" data-id="element-118">
              {['Vas a seguir repitiendo el mismo error', 'Vas a seguir comprando plantas que podrías tener gratis', 'No sabes si el problema es el corte, el sustrato o el clima', 'Si soñaste con vender plantas, ese sueño se queda en eso'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-119">
                  <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-120" />
                  <span className="text-gray-700" data-id="element-121">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {/* Why Old Methods Fail - Dark Section */}
      <div className="bg-[#2d5016] py-20 text-white" data-id="element-122">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
          <div className="max-w-4xl mx-auto" data-id="element-124">
            <div className="text-center mb-12" data-id="element-125">
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-126">
                El problema no eres tú
              </h2>
              <p className="text-xl text-[#6b9d3e] font-medium" data-id="element-127">
                El problema es la información incompleta que encontraste.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-128">
              {[{
              title: 'Videos que muestran "3 pasos fáciles"',
              desc: 'YouTube te muestra pasos sueltos. Pero nadie te explica el sistema completo ni por qué cada paso funciona.'
            }, {
              title: 'Nadie te dice qué tipo de esqueje usar',
              desc: 'Cada planta necesita una técnica diferente. Sin eso, estás adivinando.'
            }, {
              title: 'El momento del corte cambia todo',
              desc: 'Te dicen qué hacer pero no te explican cuándo hacerlo. Y el timing es clave.'
            }, {
              title: 'Nadie te enseña a escalar',
              desc: 'Si quieres transformar esto en un negocio, necesitas un método — no consejos sueltos.'
            }].map((point, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10" data-id="element-129">
                  <AlertTriangle className="w-8 h-8 text-[#6b9d3e] mb-4" data-id="element-130" />
                  <h3 className="text-lg font-bold mb-2" data-id="element-131">{point.title}</h3>
                  <p className="text-gray-300" data-id="element-132">{point.desc}</p>
                </motion.div>)}
            </div>

            <div className="text-center mt-12" data-id="element-133">
              <p className="text-2xl font-light italic opacity-90" data-id="element-134">
                "Eso es exactamente lo que esta guía resuelve."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}